// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-control-settings {\n   \n    background-color: #f4f7f8;\n    width: 100%;\n    max-width: 100%;\n}", "",{"version":3,"sources":["webpack://./src/components/search-form/searchform.style.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB","sourcesContent":[".form-control-settings {\n   \n    background-color: #f4f7f8;\n    width: 100%;\n    max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
